import get from 'lodash/get';
import moment from 'moment-timezone';
import thousands from 'thousands';
import common from './common';

import StatusChip from 'components/status-chip';
import { dateToString, localizeFund } from 'lib/utils';

export const headCells = [
  {
    id: 'nextBillingTime',
    label: 'Next Billing Date',
    width: 180,
    render: ({ row }) => dateToString(get(row, 'nextBillingTime')),
  },
  {
    id: 'amount',
    label: 'Recurring Monthly Amount',
    width: 180,
    render: ({ row }) => {
      const _givings = get(row, 'givings', []);
      if (_givings.length === 0) return '-';

      return 'HKD ' + thousands((get(row, ['givings', _givings.length - 1, 'amount'], 0) ?? 0).toFixed(2));
    },
  },
  {
    id: 'fund',
    label: 'Fund',
    width: 160,
    render: ({ row, locale }) => {
      const _givings = get(row, 'givings', []);
      if (_givings.length === 0) return '-';

      const fund = get(row, ['givings', _givings.length - 1, 'fund'], {});
      return localizeFund(fund, locale);
    }
  },
  {
    id: 'paymentMethod',
    label: 'Payment Method',
    width: 180,
    render: ({ row }) => {
      const _givings = get(row, 'givings', []);
      if (_givings.length === 0) return '-';

      const giving = row.givings[row.givings.length - 1];
      return get(giving, 'onlinePayment.paymentMethod') || '-';
    }
  },
  {
    id: 'status',
    label: 'Planned Status',
    width: 120,
    render: ({ row }) => <StatusChip status={row.status === 'Enabled' ? 'Active' : row.status === 'Disabled' ? 'Cancelled' : row.status} />,
  },
  {
    id: 'startTime',
    type: 'date',
    label: 'Start Date',
    width: 140,
    render: ({ row }) => {
      if (!row.startTime) return '-';
      return moment(row.startTime).tz('Asia/Hong_Kong').format('DD/MM/YYYY');
    },
  },
  {
    id: 'refId',
    label: 'Ref ID',
    width: 150,
    render: ({ row }) => <code>{row.refId}</code>,
  },
  {
    label: 'Actions',
    type: 'actions',
    actions: ['view', 'unsubscribe'],
  },
];

export const validationRules = {
  qfpaySubscriptionId: {
    maxLength: common.validationRules.maxLength255,
  },
  customerId: {
    maxLength: common.validationRules.maxLength255,
  },
  tokenId: {
    maxLength: common.validationRules.maxLength255,
  },
  startTime: {
    validate: common.validationRules.date,
  },
};

export const fields = {
  id: {
    name: 'id',
    type: 'hidden',
    readOnly: true,
  },
  status: {
    name: 'status',
    label: 'Status',
    type: 'text',
    readOnly: true,
  },
  qfpaySubscriptionId: {
    name: 'qfpaySubscriptionId',
    label: 'Subscription ID',
    type: 'text',
    readOnly: true,
  },
  customerId: {
    name: 'customerId',
    label: 'Customer ID',
    type: 'text',
    readOnly: true,
  },
  tokenId: {
    name: 'tokenId',
    label: 'Token ID',
    type: 'text',
    readOnly: true,
  },
  startTime: {
    name: 'startTime',
    label: 'Start Date',
    type: 'date',
    readOnly: true,
  },
  amount: {
    name: 'amount',
    label: 'Amount (HKD)',
    type: 'number',
    readOnly: true,
  },
  type: {
    name: 'type',
    label: 'Type',
    type: 'text',
    readOnly: true,
  },
};

export const form = {
  create: [
    ['status'],
    ['qfpaySubscriptionId'],
    ['customerId'],
    ['tokenId'],
    ['startTime'],
    ['amount', 'type'],
  ],
  edit: [
    ['status'],
    ['qfpaySubscriptionId'],
    ['customerId'],
    ['tokenId'],
    ['startTime'],
    ['amount', 'type'],
  ],
  view: [
    ['status'],
    ['qfpaySubscriptionId'],
    ['customerId'],
    ['tokenId'],
    ['startTime'],
    ['amount', 'type'],
  ],
};

export const optionFilters = [];

export default {
  validationRules,
  headCells,
  fields,
  form,
  optionFilters,
};
